import { url } from "../Funciones"
export default function Mapa({enlaces,enlaces_en,subenlaces,subenlaces_en}) {
    const idioma=localStorage.getItem("idioma") || "es"
    let sublinks=Array.from({length:subenlaces.length},(_,i)=>(
        <li><a href={'/productos-y-servicios/'+url(subenlaces[i])}>{idioma=="en"?subenlaces_en[i].replace(" "," - "):subenlaces[i].replace(" "," - ")}</a></li>
    ))
    let links=Array.from({length:enlaces.length},(_,i)=>(
        <li>
            <a href={'/'+url(enlaces[i])}>{idioma=="en"?enlaces_en[i]:enlaces[i]}</a>
            {url(enlaces[i])=="productos-y-servicios"?
                <ul className="mapa">
                    {sublinks}
                </ul>:null}
        </li>
    ))
    return (
        <div>
            <h2>{idioma=="en"?"SITE MAP":"MAPA DEL SITIO"}</h2>
            <ul className="mapa">
                {links}
            </ul>
        </div>
    )
}